import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormTitle, FormItem } from 'components/shared';
import useSubForm from 'hooks/useSubForm';
import { TextFieldElement } from 'components/muiInputWrappers';

const CustomTextField = styled(TextFieldElement)(() => ({
  '.MuiFormHelperText-root': {
    position: 'absolute',
    top: '-20px',
    right: '5px'
  }
}));

export type FormFields = {
  textoTxtar?: string;
};

type Props = {
  form: UseFormReturn<any, any>;
  name: string;
  title?: string;
  maxLength?: number;
  isRequired?: boolean;
  ptnum?: number;
  readonly?: boolean;
  placeholder?: string;
  moreValidations?: any;
  styleActive?: boolean;
};

function TextArea({
  form,
  name,
  title,
  ptnum,
  maxLength = 5000,
  isRequired = false,
  readonly,
  placeholder = 'common.commonProperties.comments',
  moreValidations,
  styleActive
}: Props) {
  const { control, getName } = useSubForm<FormFields>({
    form,
    name
  });

  const { t } = useTranslation('global');
  return (
    <Grid spacing={2} sx={{ pt: ptnum }} container>
      <Grid lg={12} md={12} sm={12} xs={12} item>
        {title && (
          <FormTitle variant="body2" gutterBottom>
            {title || `* ${t('common.commonProperties.description')}`}
          </FormTitle>
        )}
        <FormItem>
          <CustomTextField
            control={control}
            disabled={readonly}
            name={getName('textoTxtar')}
            placeholder={t(placeholder)}
            rows={4}
            style={styleActive && { backgroundColor: '#fafeff' }}
            validation={{
              required: {
                value: isRequired,
                message: t('common.commonMessages.requiredField')
              },
              maxLength: {
                value: maxLength,
                message: t('common.commonMessages.maxLength', {
                  number: maxLength
                })
              },
              validate: moreValidations
            }}
            fullWidth
            multiline
          />
        </FormItem>
      </Grid>
    </Grid>
  );
}

export default TextArea;
